import { CustomerModel } from 'api-hooks/customer';
import { CustomerTypeEnum } from 'common/constants/enum';
import { generateId } from 'common/utils/string';
import React from 'react';

import {
  CustomerBillingFormType,
  CustomerFormType,
} from '../components/form-type';

export default function useGetDefaultValues(
  customer?: CustomerModel,
): CustomerFormType {
  const defaultValues = React.useMemo<CustomerFormType>(() => {
    const system = customer?.system;
    const billings: CustomerBillingFormType[] = (customer?.billings || []).map(
      (billing) => {
        return {
          id: billing.id,
          accountNumber: billing.accountNumber || '',
          address: billing.address || '',
          bank: billing.bank || '',
          customId: generateId(),
          name: billing.name || '',
          phone: billing.phone || '',
          phone_2: billing.phone_2 || '',
        };
      },
    );
    return {
      address: customer?.address || '',
      alias: customer?.alias || '',
      balance: customer?.balance || 0,
      description: customer?.description || '',
      email: customer?.email || '',
      name: customer?.name || '',
      phone: customer?.phone || '',
      phone_2: customer?.phone_2 || '',
      religion: customer?.religion || '',
      title: customer?.title || null,
      type: customer?.type || CustomerTypeEnum.Individual,
      system: {
        duePeriod: system?.duePeriod || 0,
        isTransactionLimited: system?.isTransactionLimited || false,
        transactionLimit: system?.transactionLimit || 0,
        remainingTransactionQuota: system?.remainingTransactionQuota || 0,
      },
      data: customer,
      billings,
    };
  }, [customer]);

  return defaultValues;
}
